export const MERGE_FAQ_URL =
  'https://faq.allwhere.co/en_us/hris-integration-BkZVxpyIT';

export const EMAIL_INFO_HELPER_TEXT =
  'Please enter the email address of the account that will be used to authenticate this integration. This person should be an admin for the HRIS/Payroll/SCIM system.';
